var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.951,
    height: 45.26,
    viewBox: "0 0 26.951 45.26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    "data-name": "Group 3",
    transform: "translate(0.417 0.417)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11",
    "data-name": "Path 11",
    d: "M1225.843,649.768a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1216.471 -649.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12",
    "data-name": "Path 12",
    d: "M1225.843,649.768a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1225.843,649.768Z",
    transform: "translate(-1216.471 -649.269)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1338.721,649.768a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1325.163 -649.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1338.721,649.768a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1338.721,649.768Z",
    transform: "translate(-1325.163 -649.269)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1451.6,649.768a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1433.855 -649.269)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1451.6,649.768a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1451.6,649.768Z",
    transform: "translate(-1433.855 -649.269)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1109.071,735.787a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -731.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1109.071,735.787a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,735.787Z",
    transform: "translate(-1103.73 -731.947)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1221.948,735.787a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1212.42 -731.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_20",
    "data-name": "Path 20",
    d: "M1221.948,735.787a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1221.948,735.787Z",
    transform: "translate(-1212.42 -731.947)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21",
    "data-name": "Path 21",
    d: "M1334.826,735.787a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1321.112 -731.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_22",
    "data-name": "Path 22",
    d: "M1334.826,735.787a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1334.826,735.787Z",
    transform: "translate(-1321.112 -731.947)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_23",
    "data-name": "Path 23",
    d: "M1447.7,735.787a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1429.804 -731.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24",
    "data-name": "Path 24",
    d: "M1447.7,735.787a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1447.7,735.787Z",
    transform: "translate(-1429.804 -731.947)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_25",
    "data-name": "Path 25",
    d: "M1560.582,735.787a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -731.947)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_26",
    "data-name": "Path 26",
    d: "M1560.582,735.787a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,735.787Z",
    transform: "translate(-1538.495 -731.947)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_27",
    "data-name": "Path 27",
    d: "M1000.088,829.917a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -822.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_28",
    "data-name": "Path 28",
    d: "M1000.088,829.917a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,829.917Z",
    transform: "translate(-999.089 -822.737)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_29",
    "data-name": "Path 29",
    d: "M1109.071,825.862a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -818.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30",
    "data-name": "Path 30",
    d: "M1109.071,825.862a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,825.862Z",
    transform: "translate(-1103.73 -818.681)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M1217.531,821.268a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1207.826 -814.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M1217.531,821.268a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1217.531,821.268Z",
    transform: "translate(-1207.826 -814.087)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33",
    "data-name": "Path 33",
    d: "M1330.409,821.268a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1316.518 -814.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_34",
    "data-name": "Path 34",
    d: "M1330.409,821.268a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1330.409,821.268Z",
    transform: "translate(-1316.518 -814.087)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_35",
    "data-name": "Path 35",
    d: "M1443.287,821.268a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1425.21 -814.087)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36",
    "data-name": "Path 36",
    d: "M1443.287,821.268a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1443.287,821.268Z",
    transform: "translate(-1425.21 -814.087)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_37",
    "data-name": "Path 37",
    d: "M1560.582,825.862a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -818.681)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_38",
    "data-name": "Path 38",
    d: "M1560.582,825.862a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,825.862Z",
    transform: "translate(-1538.495 -818.681)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39",
    "data-name": "Path 39",
    d: "M1677.355,829.917a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -822.737)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_40",
    "data-name": "Path 40",
    d: "M1677.355,829.917a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,829.917Z",
    transform: "translate(-1651.238 -822.737)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_41",
    "data-name": "Path 41",
    d: "M1000.088,919.991a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -909.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_42",
    "data-name": "Path 42",
    d: "M1000.088,919.991a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,919.991Z",
    transform: "translate(-999.089 -909.47)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_43",
    "data-name": "Path 43",
    d: "M1109.071,915.936a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -905.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_44",
    "data-name": "Path 44",
    d: "M1109.071,915.936a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,915.936Z",
    transform: "translate(-1103.73 -905.415)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_45",
    "data-name": "Path 45",
    d: "M1217.531,911.342a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1207.826 -900.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_46",
    "data-name": "Path 46",
    d: "M1217.531,911.342a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1217.531,911.342Z",
    transform: "translate(-1207.826 -900.82)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_47",
    "data-name": "Path 47",
    d: "M1443.287,911.342a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1425.21 -900.82)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48",
    "data-name": "Path 48",
    d: "M1443.287,911.342a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1443.287,911.342Z",
    transform: "translate(-1425.21 -900.82)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_49",
    "data-name": "Path 49",
    d: "M1560.582,915.936a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -905.415)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50",
    "data-name": "Path 50",
    d: "M1560.582,915.936a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,915.936Z",
    transform: "translate(-1538.495 -905.415)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_51",
    "data-name": "Path 51",
    d: "M1677.355,919.991a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -909.47)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_52",
    "data-name": "Path 52",
    d: "M1677.355,919.991a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,919.991Z",
    transform: "translate(-1651.238 -909.47)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_53",
    "data-name": "Path 53",
    d: "M1000.088,1010.067a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -996.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_54",
    "data-name": "Path 54",
    d: "M1000.088,1010.067a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,1010.067Z",
    transform: "translate(-999.089 -996.205)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_55",
    "data-name": "Path 55",
    d: "M1109.071,1006.011a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -992.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M1109.071,1006.011a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1006.011Z",
    transform: "translate(-1103.73 -992.149)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M1217.531,1001.417a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1207.826 -987.555)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_58",
    "data-name": "Path 58",
    d: "M1217.531,1001.417a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1217.531,1001.417Z",
    transform: "translate(-1207.826 -987.555)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_59",
    "data-name": "Path 59",
    d: "M1560.582,1006.011a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -992.149)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_60",
    "data-name": "Path 60",
    d: "M1560.582,1006.011a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1006.011Z",
    transform: "translate(-1538.495 -992.149)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_61",
    "data-name": "Path 61",
    d: "M1677.355,1010.067a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -996.205)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_62",
    "data-name": "Path 62",
    d: "M1677.355,1010.067a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,1010.067Z",
    transform: "translate(-1651.238 -996.205)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63",
    "data-name": "Path 63",
    d: "M1000.088,1100.14a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -1082.938)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_64",
    "data-name": "Path 64",
    d: "M1000.088,1100.14a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,1100.14Z",
    transform: "translate(-999.089 -1082.938)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_65",
    "data-name": "Path 65",
    d: "M1109.071,1096.085a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1078.882)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_66",
    "data-name": "Path 66",
    d: "M1109.071,1096.085a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1096.085Z",
    transform: "translate(-1103.73 -1078.882)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_67",
    "data-name": "Path 67",
    d: "M1214.93,1088.789a.937.937,0,1,1-.937-.937.937.937,0,0,1,.937.937",
    transform: "translate(-1205.121 -1071.586)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1",
    "data-name": "Ellipse 1",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(7.745 17.899) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_68",
    "data-name": "Path 68",
    d: "M1330.409,1091.49a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1316.518 -1074.288)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_69",
    "data-name": "Path 69",
    d: "M1330.409,1091.49a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1330.409,1091.49Z",
    transform: "translate(-1316.518 -1074.288)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_70",
    "data-name": "Path 70",
    d: "M1109.071,1186.159a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1165.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_71",
    "data-name": "Path 71",
    d: "M1109.071,1186.159a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1186.159Z",
    transform: "translate(-1103.73 -1165.616)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_72",
    "data-name": "Path 72",
    d: "M1214.93,1178.864a.937.937,0,1,1-.937-.937.937.937,0,0,1,.937.937",
    transform: "translate(-1205.121 -1158.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2",
    "data-name": "Ellipse 2",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "matrix(0.23, -0.973, 0.973, 0.23, 7.745, 21.239)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_73",
    "data-name": "Path 73",
    d: "M1327.808,1178.864a.937.937,0,1,1-.937-.937.937.937,0,0,1,.937.937",
    transform: "translate(-1313.813 -1158.321)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_3",
    "data-name": "Ellipse 3",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(11.932 21.239) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_74",
    "data-name": "Path 74",
    d: "M1443.287,1181.565a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1425.21 -1161.022)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_75",
    "data-name": "Path 75",
    d: "M1443.287,1181.565a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1443.287,1181.565Z",
    transform: "translate(-1425.21 -1161.022)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_76",
    "data-name": "Path 76",
    d: "M1217.531,1271.64a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1207.826 -1247.756)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_77",
    "data-name": "Path 77",
    d: "M1217.531,1271.64a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1217.531,1271.64Z",
    transform: "translate(-1207.826 -1247.756)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_78",
    "data-name": "Path 78",
    d: "M1327.808,1268.938a.937.937,0,1,1-.937-.937.937.937,0,0,1,.937.937",
    transform: "translate(-1313.813 -1245.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_4",
    "data-name": "Ellipse 4",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(11.932 24.58) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79",
    "data-name": "Path 79",
    d: "M1330.409,1361.714a.833.833,0,1,1-.833-.833.833.833,0,0,1,.833.833",
    transform: "translate(-1316.518 -1334.489)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_80",
    "data-name": "Path 80",
    d: "M1330.409,1361.714a.833.833,0,1,1-.833-.833A.833.833,0,0,1,1330.409,1361.714Z",
    transform: "translate(-1316.518 -1334.489)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_81",
    "data-name": "Path 81",
    d: "M1440.686,1268.938a.937.937,0,1,1-.937-.937.937.937,0,0,1,.937.937",
    transform: "translate(-1422.505 -1245.054)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_5",
    "data-name": "Ellipse 5",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(16.118 24.58) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_82",
    "data-name": "Path 82",
    d: "M1560.582,1276.234a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1252.35)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_83",
    "data-name": "Path 83",
    d: "M1560.582,1276.234a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1276.234Z",
    transform: "translate(-1538.495 -1252.35)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_84",
    "data-name": "Path 84",
    d: "M1440.686,1359.012a.937.937,0,1,1-.937-.937.936.936,0,0,1,.937.937",
    transform: "translate(-1422.505 -1331.788)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(16.118 27.921) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_85",
    "data-name": "Path 85",
    d: "M1440.686,1449.087a.937.937,0,1,1-.937-.937.936.936,0,0,1,.937.937",
    transform: "translate(-1422.505 -1418.522)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(16.118 31.261) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86",
    "data-name": "Path 86",
    d: "M1560.582,1366.308a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1339.083)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_87",
    "data-name": "Path 87",
    d: "M1560.582,1366.308a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1366.308Z",
    transform: "translate(-1538.495 -1339.083)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_88",
    "data-name": "Path 88",
    d: "M1677.355,1370.363a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -1343.139)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_89",
    "data-name": "Path 89",
    d: "M1677.355,1370.363a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,1370.363Z",
    transform: "translate(-1651.238 -1343.139)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_90",
    "data-name": "Path 90",
    d: "M1000.088,1460.438a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -1429.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_91",
    "data-name": "Path 91",
    d: "M1000.088,1460.438a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,1460.438Z",
    transform: "translate(-999.089 -1429.874)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_92",
    "data-name": "Path 92",
    d: "M1109.071,1456.383a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1425.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_93",
    "data-name": "Path 93",
    d: "M1109.071,1456.383a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1456.383Z",
    transform: "translate(-1103.73 -1425.818)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_94",
    "data-name": "Path 94",
    d: "M1560.582,1456.383a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1425.818)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_95",
    "data-name": "Path 95",
    d: "M1560.582,1456.383a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1456.383Z",
    transform: "translate(-1538.495 -1425.818)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_96",
    "data-name": "Path 96",
    d: "M1677.355,1460.438a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -1429.874)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_97",
    "data-name": "Path 97",
    d: "M1677.355,1460.438a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,1460.438Z",
    transform: "translate(-1651.238 -1429.874)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_98",
    "data-name": "Path 98",
    d: "M1000.088,1550.512a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -1516.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_99",
    "data-name": "Path 99",
    d: "M1000.088,1550.512a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,1550.512Z",
    transform: "translate(-999.089 -1516.607)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_100",
    "data-name": "Path 100",
    d: "M1109.071,1546.457a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1512.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_101",
    "data-name": "Path 101",
    d: "M1109.071,1546.457a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1546.457Z",
    transform: "translate(-1103.73 -1512.552)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_102",
    "data-name": "Path 102",
    d: "M1219.61,1544.026a.749.749,0,1,1-.749-.749.749.749,0,0,1,.749.749",
    transform: "translate(-1209.988 -1510.121)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 0.749,
    cy: 0.749,
    r: 0.749,
    transform: "translate(7.893 33.5) rotate(-22.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_103",
    "data-name": "Path 103",
    d: "M1440.686,1539.161a.937.937,0,1,1-.937-.937.936.936,0,0,1,.937.937",
    transform: "translate(-1422.505 -1505.256)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 0.937,
    cy: 0.937,
    r: 0.937,
    transform: "translate(16.118 34.602) rotate(-76.718)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_104",
    "data-name": "Path 104",
    d: "M1560.582,1546.457a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1512.552)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_105",
    "data-name": "Path 105",
    d: "M1560.582,1546.457a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1546.457Z",
    transform: "translate(-1538.495 -1512.552)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_106",
    "data-name": "Path 106",
    d: "M1677.355,1550.512a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -1516.607)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_107",
    "data-name": "Path 107",
    d: "M1677.355,1550.512a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,1550.512Z",
    transform: "translate(-1651.238 -1516.607)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_108",
    "data-name": "Path 108",
    d: "M1000.088,1640.587a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-999.089 -1603.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_109",
    "data-name": "Path 109",
    d: "M1000.088,1640.587a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1000.088,1640.587Z",
    transform: "translate(-999.089 -1603.342)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_110",
    "data-name": "Path 110",
    d: "M1109.071,1636.531a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1599.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_111",
    "data-name": "Path 111",
    d: "M1109.071,1636.531a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1636.531Z",
    transform: "translate(-1103.73 -1599.285)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_112",
    "data-name": "Path 112",
    d: "M1219.61,1634.1a.749.749,0,1,1-.749-.75.749.749,0,0,1,.749.75",
    transform: "translate(-1209.988 -1596.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 0.749,
    cy: 0.749,
    r: 0.749,
    transform: "translate(7.893 36.84) rotate(-22.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_113",
    "data-name": "Path 113",
    d: "M1332.488,1634.1a.749.749,0,1,1-.749-.75.749.749,0,0,1,.749.75",
    transform: "translate(-1318.68 -1596.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_11",
    "data-name": "Ellipse 11",
    cx: 0.749,
    cy: 0.749,
    r: 0.749,
    transform: "translate(12.079 36.84) rotate(-22.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M1445.365,1634.1a.749.749,0,1,1-.749-.75.749.749,0,0,1,.749.75",
    transform: "translate(-1427.371 -1596.854)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_12",
    "data-name": "Ellipse 12",
    cx: 0.749,
    cy: 0.749,
    r: 0.749,
    transform: "translate(16.266 36.84) rotate(-22.5)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M1560.582,1636.531a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1599.285)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M1560.582,1636.531a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1636.531Z",
    transform: "translate(-1538.495 -1599.285)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_117",
    "data-name": "Path 117",
    d: "M1677.355,1640.587a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1651.238 -1603.342)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_118",
    "data-name": "Path 118",
    d: "M1677.355,1640.587a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1677.355,1640.587Z",
    transform: "translate(-1651.238 -1603.342)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_119",
    "data-name": "Path 119",
    d: "M1109.071,1726.606a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1103.73 -1686.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_120",
    "data-name": "Path 120",
    d: "M1109.071,1726.606a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1109.071,1726.606Z",
    transform: "translate(-1103.73 -1686.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_121",
    "data-name": "Path 121",
    d: "M1221.948,1726.606a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1212.42 -1686.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_122",
    "data-name": "Path 122",
    d: "M1221.948,1726.606a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1221.948,1726.606Z",
    transform: "translate(-1212.42 -1686.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_123",
    "data-name": "Path 123",
    d: "M1334.826,1726.606a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1321.112 -1686.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_124",
    "data-name": "Path 124",
    d: "M1334.826,1726.606a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1334.826,1726.606Z",
    transform: "translate(-1321.112 -1686.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_125",
    "data-name": "Path 125",
    d: "M1447.7,1726.606a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1429.804 -1686.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_126",
    "data-name": "Path 126",
    d: "M1447.7,1726.606a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1447.7,1726.606Z",
    transform: "translate(-1429.804 -1686.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_127",
    "data-name": "Path 127",
    d: "M1560.582,1726.606a.656.656,0,1,1-.656-.656.656.656,0,0,1,.656.656",
    transform: "translate(-1538.495 -1686.019)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_128",
    "data-name": "Path 128",
    d: "M1560.582,1726.606a.656.656,0,1,1-.656-.656A.656.656,0,0,1,1560.582,1726.606Z",
    transform: "translate(-1538.495 -1686.019)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_129",
    "data-name": "Path 129",
    d: "M1225.843,1820.736a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1216.471 -1776.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_130",
    "data-name": "Path 130",
    d: "M1225.843,1820.736a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1225.843,1820.736Z",
    transform: "translate(-1216.471 -1776.809)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_131",
    "data-name": "Path 131",
    d: "M1338.721,1820.736a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1325.163 -1776.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_132",
    "data-name": "Path 132",
    d: "M1338.721,1820.736a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1338.721,1820.736Z",
    transform: "translate(-1325.163 -1776.809)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_133",
    "data-name": "Path 133",
    d: "M1451.6,1820.736a.5.5,0,1,1-.5-.5.5.5,0,0,1,.5.5",
    transform: "translate(-1433.855 -1776.809)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_134",
    "data-name": "Path 134",
    d: "M1451.6,1820.736a.5.5,0,1,1-.5-.5A.5.5,0,0,1,1451.6,1820.736Z",
    transform: "translate(-1433.855 -1776.809)",
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.834
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.baa8020e2cc15149b86740e44b1d654b.svg";
export { ForwardRef as ReactComponent };